import { useGetUserMe } from '@/api/REST/userMe';

export const useHasPermissionToAccessPage = (
  pageIdentifier: string,
): { hasPermission: boolean; isLoading: boolean } => {
  const { data: userMeData, isLoading } = useGetUserMe();
  return {
    hasPermission:
      userMeData?.permittedPages?.some(
        (permission) => permission.pageIdentifier === pageIdentifier,
      ) ?? false,
    isLoading,
  };
};
